import {
  WSActions,
  WSCard,
  WSEmptyState,
  WSList
} from "@wingspanhq/fe-component-library";
import { EditPayeeSetupParams } from "./index";
import { SetupRouteComponentProps } from "../../../../shared/components/FlowSetup";
import React from "react";
import { ComplianceEntityType } from "@wingspanhq/wingspan-api-sdk";

type Props = SetupRouteComponentProps<EditPayeeSetupParams>;

export const EditPayeeTaxInfoVerificationPending: React.FC<Props> = ({
  onNext,
  params
}) => {
  const tinTypeLabel =
    params?.complianceEntity?.type === ComplianceEntityType.INDIVIDUAL
      ? "SSN"
      : "EIN";

  return (
    <WSList gap="2XL">
      <WSCard>
        <WSEmptyState
          type="tasks"
          title={`Contractor’s ${tinTypeLabel} verification is pending`}
          description={`The IRS is currently verifying the contractor’s ${tinTypeLabel}. Click continue for the next step`}
          orientation="horizontal"
        />
      </WSCard>
      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Continue",
            onClick: onNext
          }
        ]}
      />
    </WSList>
  );
};
